module.exports = __webpack_public_path__ + "img/pencil.7d7c207b.svg";